<template>
  <h3 class="pb5">Imprimer rapport ambulances (CDX_0226)</h3>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";

export default {
  name: "DossiersAmbulanceImprimer",
  components: {ButtonBar},
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Divers");
  },
  methods: {
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      var criteresRapportVO;
      criteresRapportVO.titre = "DossiersAmbulanceImprimer";
      this.$store.dispatch("rapports/obtenirRapportDiversAction", {
        criteresRapportVO: criteresRapportVO
      })
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  },
}
</script>